import TreatmentQueue from 'locales/plus/th/dentist/treatmentsQueue.json'
import Treatments from 'locales/plus/th/dentist/treatments.json'
import vitalSign from 'locales/plus/th/dentist/treatmentsVital-sign.json'
import treatmentsDx from 'locales/plus/th/dentist/treatmentsDx.json'
import Summary from 'locales/plus/th/dentist/summary.json'
import Opd from 'locales/plus/th/dentist/opd.json'
import Tx from 'locales/plus/th/dentist/treatmentsTx.json'
import Product from 'locales/plus/th/dentist/treatmentsProduct.json'
import Emr from 'locales/plus/th/dentist/treatmentsEmr.json'
import TreatmentDocument from 'locales/plus/th/dentist/treatmentDocument.json'
import TxInformationBox from 'locales/plus/th/dentist/txInFormationBox.json'
import TreatmentsTxp from 'locales/plus/th/dentist/treatmentsTxp.json'
import TreatmentsTxc from 'locales/plus/th/dentist/treatmentsTxc.json'
import PdfStickerMed from 'locales/plus/th/dentist/pdfStickerMed.json'
import Xray from 'locales/plus/th/dentist/xray.json'
import PDFInvoice from 'locales/plus/th/dentist/pdfInvoice.json'

export const Treatment = {
  ...TreatmentQueue,
  ...Treatments,
  ...vitalSign,
  ...treatmentsDx,
  ...Summary,
  ...Opd,
  ...Tx,
  ...Product,
  ...Emr,
  ...TreatmentDocument,
  ...TxInformationBox,
  ...TreatmentsTxp,
  ...TreatmentsTxc,
  ...PdfStickerMed,
  ...Xray,
  ...PDFInvoice
}
